export const palette = {
  parchment: "oklch(0.965 0.012 82)",
  parchmentDeep: "oklch(0.935 0.018 80)",
  claret: "oklch(0.36 0.11 18)",
  claretDeep: "oklch(0.28 0.11 20)",
  rose: "oklch(0.74 0.075 20)",
  roseSoft: "oklch(0.86 0.04 22)",
  gilt: "oklch(0.76 0.095 82)",
  giltDeep: "oklch(0.58 0.11 72)",
  ink: "oklch(0.24 0.03 38)",
};

export const easeManor = [0.22, 1, 0.36, 1] as const;
